export const ID = "jp_dev";
export const PASSWORD = "ejhfu473hd2";
